import type { Idioma } from '../../i18n/index.js';

const es = {
  titulo: 'Purgas y dominios bloqueados',
  explicacion:
    'Purgar borra de verdad un estudio: su ficha, sus hechos, sus fragmentos, sus páginas y su PDF. No se puede deshacer. Las respuestas que ya se dieron a los usuarios no se tocan.',
  dominios: 'Dominios (separados por comas)',
  slugs: 'Identificadores de estudios (separados por comas)',
  buscar: 'Vista previa',
  encontrados: 'Estudios que se borrarán',
  parecidos: 'Estudios de otro dominio cuyo editor se parece (no están marcados: márcalos solo si son del mismo autor)',
  ninguno: 'No hay estudios con esos datos.',
  hechos: 'hechos',
  enPortada: 'Una sugerencia de la portada cita este estudio: hay que regenerarla antes de purgar.',
  retirado: 'retirado',
  bloquearTambien: 'Bloquear también estos dominios para que no entren estudios nuevos:',
  sugerido: 'sale de sus URL: márcalo solo si es del autor, no de un medio o un distribuidor',
  motivo: 'Motivo (quién lo pide y cuándo)',
  solicitante: 'Correo de quien lo pide',
  confirmar: 'Para confirmar, escribe el número de estudios que se van a borrar:',
  purgar: 'Purgar',
  purgado: (n: number) => (n === 1 ? 'Purgado 1 estudio.' : `Purgados ${String(n)} estudios.`),
  pendientes: 'Algunos PDF no se pudieron borrar de Storage y quedan pendientes en el registro.',
  listaNegra: 'Dominios bloqueados',
  sinBloqueados: 'No hay dominios bloqueados.',
  dominio: 'Dominio',
  motivoBloqueo: 'Motivo del bloqueo',
  bloquear: 'Bloquear',
  desbloquear: 'Desbloquear',
  porAutor: 'lo pidió el autor',
  editores: 'Dominios de las cuentas de editor',
  explicacionEditores:
    'Una cuenta de editor solo puede purgar y bloquear los estudios de sus dominios. Sin dominio, se propone el de su correo: compruébalo antes de guardar.',
  correo: 'Correo de la cuenta',
  dominioEditor: 'Dominio (vacío: el de su correo)',
  anadir: 'Añadir dominio',
  quitar: 'Quitar',
  sinPermiso: 'sin permiso de editor',
  registro: 'Registro de purgas',
  sinRegistro: 'Todavía no hay purgas.',
  reintentar: 'Reintentar borrar los PDF',
  error: 'No se pudo completar la operación.',
  guardado: 'Hecho.',
  cargando: 'Cargando…',
  misTitulo: 'Retirar mis estudios de Athena',
  misExplicacion: (dominios: string) =>
    `Estos son los estudios de tus dominios (${dominios}) y los que enviaste tú. Si los purgas, Athena los quita de su catálogo y deja de usarlos para responder. No se puede deshacer.`,
  misNinguno: 'No encontramos estudios con el PDF en tus dominios. Si falta alguno, escríbenos a athena@sinapser.com.',
  misBloquear: 'Bloquear mi dominio: Athena no incorporará estudios nuevos de él. Los que ya están se quitan purgándolos.',
  misBloqueado: 'bloqueado',
  misBloquearBoton: (d: string) => `Bloquear ${d}`,
};

const en: typeof es = {
  titulo: 'Purges and blocked domains',
  explicacion:
    'Purging permanently deletes a study: its record, its facts, its chunks, its pages and its PDF. It cannot be undone. Answers already given to users are not changed.',
  dominios: 'Domains (comma separated)',
  slugs: 'Study identifiers (comma separated)',
  buscar: 'Preview',
  encontrados: 'Studies that will be deleted',
  parecidos: 'Studies on another domain with a similar publisher (not selected: select them only if they belong to the same author)',
  ninguno: 'No studies match.',
  hechos: 'facts',
  enPortada: 'A home page suggestion cites this study: it must be regenerated before purging.',
  retirado: 'withdrawn',
  bloquearTambien: 'Also block these domains so no new studies come in:',
  sugerido: 'taken from their URLs: select it only if it belongs to the author, not to a news site or a distributor',
  motivo: 'Reason (who asks and when)',
  solicitante: 'Email of the person asking',
  confirmar: 'To confirm, type the number of studies that will be deleted:',
  purgar: 'Purge',
  purgado: (n: number) => (n === 1 ? '1 study purged.' : `${String(n)} studies purged.`),
  pendientes: 'Some PDFs could not be deleted from Storage and remain pending in the log.',
  listaNegra: 'Blocked domains',
  sinBloqueados: 'No blocked domains.',
  dominio: 'Domain',
  motivoBloqueo: 'Reason for blocking',
  bloquear: 'Block',
  desbloquear: 'Unblock',
  porAutor: 'requested by the author',
  editores: 'Publisher account domains',
  explicacionEditores:
    'A publisher account can only purge and block studies from its own domains. If left empty, the domain of its email is proposed: check it before saving.',
  correo: 'Account email',
  dominioEditor: 'Domain (empty: its email domain)',
  anadir: 'Add domain',
  quitar: 'Remove',
  sinPermiso: 'no publisher permission',
  registro: 'Purge log',
  sinRegistro: 'No purges yet.',
  reintentar: 'Retry deleting the PDFs',
  error: 'The operation could not be completed.',
  guardado: 'Done.',
  cargando: 'Loading…',
  misTitulo: 'Remove my studies from Athena',
  misExplicacion: (dominios: string) =>
    `These are the studies from your domains (${dominios}) and the ones you submitted. If you purge them, Athena removes them from its catalogue and stops using them to answer. It cannot be undone.`,
  misNinguno: 'We found no studies with the PDF on your domains. If one is missing, write to athena@sinapser.com.',
  misBloquear: 'Block my domain: Athena will not add new studies from it. The ones already in Athena are removed by purging them.',
  misBloqueado: 'blocked',
  misBloquearBoton: (d: string) => `Block ${d}`,
};

export const textosPurgas = (idioma: Idioma) => (idioma === 'en' ? en : es);
